import { Descriptions, Drawer, Spin } from 'antd';
import React, { FC, useEffect } from 'react';
import styles from './index.module.scss';
import { Button, EllipsisSpan, Form, ShowInput, Table, Tag } from '@maxtropy/components';
import { SwitchStatusColor } from '../../const';
import { SwitchStatusType, SwitchStatusTypeFormat } from '@/api/circuit';
import { isNil } from 'lodash-es';

export interface IDetailDrawer {
  visible: boolean;
  recordData: any;
  onClose: () => void;
}

const { Item } = Form;

// 总开回路
const mainSwitchColumns = [
  {
    title: '回路名称',
    dataIndex: 'circuitName',
    // width: 180,
    fixed: 'left' as 'left',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '开关状态',
    dataIndex: 'switchStatus',
    ellipsis: { showTitle: true },
    width: 130,
    render: (v: SwitchStatusType) => (
      <Tag color={SwitchStatusColor[v]} border="solid">
        {SwitchStatusTypeFormat[v]}
      </Tag>
    ),
  },
  {
    title: '得电母排',
    width: 130,
    dataIndex: 'electricBusbar',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
];

// 监测回路
const monitorColumns = [
  {
    title: '回路名称',
    dataIndex: 'circuitName',
    // width: 180,
    fixed: 'left' as 'left',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v} />,
  },
  {
    title: '实时功率（kW）',
    width: 130,
    dataIndex: 'realTimePower',
    ellipsis: { showTitle: true },
    render: (v: number) => (
      <EllipsisSpan value={<span style={{ color: '#FAAD14' }}>{!isNil(v) ? v.toFixed(2) : '--'}</span>} />
    ),
  },
  {
    title: '装机容量（kVA）',
    width: 130,
    dataIndex: 'capacity',
    ellipsis: { showTitle: true },
    render: (v: number) => <EllipsisSpan value={!isNil(v) ? v.toFixed(2) : '--'} />,
  },
];

const DetailDrawer: FC<IDetailDrawer> = props => {
  const { visible, recordData, onClose } = props;
  const [form] = Form.useForm();

  useEffect(() => {
    if (!recordData) return;
    form.setFieldsValue({
      stationName: recordData?.item?.name,
      superiorStation: recordData?.parentItem?.name,
      gridBillingCircuit: recordData?.circuitItem?.circuitName,
    });
  }, [recordData]);

  return (
    <div className={styles.drawerStyle}>
      <Drawer
        title={
          <div className={styles.drawertitleStyle}>
            <div className={styles.drawertitleLeftStyle}>详情</div>
            <Button
              type="link"
              onClick={() => window.open(`/power/station/configuration?stationId=${recordData?.item?.id}`, '_blank')}
            >
              查看站房一次接线图
            </Button>
          </div>
        }
        open={visible}
        width={640}
        style={{ marginTop: 50 }}
        destroyOnClose
        getContainer={() => document.body} // 强制 portal 到 body
        mask={false}
        onClose={() => {
          form.resetFields();
          onClose?.();
        }}
      >
        <Spin spinning={false}>
          <Form form={form}>
            <Descriptions labelStyle={{ width: '40%' }} title={null} bordered column={1} size="small">
              <Descriptions.Item label="站房名称">
                <Item name="stationName" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              {recordData?.parentItem?.name && (
                <Descriptions.Item label="上级站房">
                  <Item name="superiorStation" style={{ marginBottom: 0 }}>
                    <ShowInput />
                  </Item>
                </Descriptions.Item>
              )}
              <Descriptions.Item label="得电电网计费回路">
                <Item name="gridBillingCircuit" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
            </Descriptions>

            <div className={styles.preview}>
              <div className={styles.previewBtn} style={{ marginTop: 16, marginBottom: 8 }}>
                上级至该站房总开回路
              </div>

              <Table
                style={{ marginTop: 8 }}
                rowKey="circuitId"
                columns={mainSwitchColumns}
                // scroll={{ x: 580 }}
                dataSource={(recordData?.item?.itemList ?? []).map((item: any) => ({
                  ...item,
                  switchStatus: SwitchStatusType.CLOSE,
                  electricBusbar: recordData?.busPaiItem?.busPaiName,
                }))}
              />

              <div className={styles.previewBtn} style={{ marginTop: 16, marginBottom: 8 }}>
                站房监测回路
              </div>

              <Table
                style={{ marginTop: 8 }}
                rowKey="circuitId"
                columns={monitorColumns}
                // scroll={{ x: 580 }}
                dataSource={recordData?.item?.monitorItemList ?? []}
              />
            </div>
          </Form>
        </Spin>
      </Drawer>
    </div>
  );
};

export default DetailDrawer;
